import { CORPORATE_CLIENT_COUNTRIES } from 'constants/corporateClients';

export const WALLET_NAME_MIN_LENGTH = 4;
export const WALLET_NAME_MAX_LENGTH = 30;

export const LOW_BALANCE_ALERT_PRESETS = [100, 500, 1000];
export const LOW_BALANCE_ALERT_DEFAULT = 500;

// Placeholder URLs — the real region-based terms and conditions links are TBD from product
export const WALLET_TERMS_AND_CONDITIONS_LINKS = {
  [CORPORATE_CLIENT_COUNTRIES.GB]: 'https://www.google.co.uk',
  [CORPORATE_CLIENT_COUNTRIES.FR]: 'https://www.google.fr',
  [CORPORATE_CLIENT_COUNTRIES.DE]: 'https://www.google.de',
  default: 'https://www.google.com',
};

// Placeholder — the real region-based wallet support phone numbers are TBD from product
export const WALLET_SUPPORT_PHONE_NUMBERS = {
  default: '8888888888',
};
